/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import AppBase from '@jira/platform__utils-app-base/src/index.tsx';
import type { Breadcrumb } from './model/types.tsx';
import BreadcrumbNav from './view/view.tsx';

type Props = {
	isVisible: boolean;
	items: Breadcrumb[];
};

export default function BreadcrumbNavApp(props: Props): React.JSX.Element {
	const { isVisible, items } = props;
	return (
		<AppBase>
			<BreadcrumbNav isVisible={isVisible} items={items} />
		</AppBase>
	);
}
